import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IProgramsState, IStepOne } from './types/StepOne-interface'

const StepOneState = (state: RootState): IStepOne => state.StepOneHealth

export const FormFieldsStepOne = createSelector(
    [StepOneState],
    (state): IStepOne => state,
)

export const programs = createSelector(
    [StepOneState],
    (state): IProgramsState => state.Programs,
)

